/**
 * useCoupons
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import CouponsContext from './coupons-context'

const useCoupons = () => {
  const context = useContext(CouponsContext)
  return context
}

export default useCoupons
